// ArticleList.js

import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { HiEye } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import ArticleDetails from "./ArticleDetails"; // Assuming ArticleDetails component is in the same directory
import './articleManagement.css';
import { useDispatch } from "react-redux";
function ArticleList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [counting, setCounting] = useState({});
  const [alertLoader, setAlertLoader] = useState(false);
  const [showAlter, setShowAlter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loader, setLoader] = useState(false);
  const [userId, setUserId] = useState(null);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedArticleId, setSelectedArticleId] = useState(null);

  const pageSize = 10;

  const fetchUsers = async (pageNumber, query = "") => {
    try {
      setLoader(true);
      const filterData = {
        pageSize,
        pageNumber,
        sortField: "createdAt",
        sortOrder: "desc",
        role: "provider",
        search: query,
        isDeleted: "false",
      };
      const getAllArticles = await ApiClient.post(
        "api/admin/get-all-artilces",
        filterData,
        true,
        dispatch
      );
      console.log(getAllArticles,"getAllArticles")
      setArticles(getAllArticles.data.articles);
      setCounting(getAllArticles.data);
      setLoader(false);
    } catch (error) {
      // toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const openAlertDialog = (id) => {
    setUserId(id);
    setShowAlter(true);
  };

  const handleDelete = async () => {
    if (userId) {
      try {
        setAlertLoader(true);
        const deleteUser = await ApiClient.delete(
          `api/admin/delete-article`,
          { id: userId },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchUsers(currentPage, searchQuery);
        toast.success(deleteUser.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const viewDetails = (id) => {
    setSelectedArticleId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedArticleId(null);
    setIsModalOpen(false);
  };

  const toggleDescription = (id) => {
    setExpandedDescriptions((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleUpdateArticle=(id)=>{
    console.log(id,"addassa")
    navigate(`/admin/article/update?id=${id}`);
  }
  const formatDate = dateString => new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });

  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Articles</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="8">
                    {/* <CardTitle className="card-list-title" tag="h4">Provider List</CardTitle> */}
                  </Col>
                  <Col md="4">
                    <form>
                      <InputGroup className="no-border">
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                          <InputGroupText>
                            <i className="nc-icon nc-zoom-split" />
                          </InputGroupText>
                      </InputGroup>
                    </form>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Title</th>
                          <th>Created Date</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {articles?.map((article) => {
                          const isExpanded = expandedDescriptions[article?._id];
                          const truncatedDescription =
                            article?.description.length > 50
                              ? `${article?.description.substring(0, 50)}...`
                              : article?.description;
                          return (
                            <tr key={article?._id}>
                              <td>{article?.articleName}</td>
                              <td>{article?.title}</td>
                              <td>{formatDate(article?.createdAt)}</td>
                              {/* <td>
              {isExpanded ? (
                <div dangerouslySetInnerHTML={{ __html: article?.description }} />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: truncatedDescription }} />
              )}
              {article?.description?.length > 50 && (
                <a
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDescription(article._id);
                  }}
                  style={{
                    color: "#007bff",
                    textDecoration: "none",
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                >
                  {isExpanded ? " Show less" : " Read more"}
                </a>
              )}
                              </td> */}
                              <td className="text-center">
                              <span
                                  className="action-icon"
                                  onClick={() => viewDetails(article._id)}
                                >
                                  <HiEye />
                                </span>
                                <span className="action-icon action-icon-yellow"
                                 onClick={() => handleUpdateArticle(article._id)}>
                                  <MdModeEdit />
                                </span>
                                <span
                                  className="action-icon action-icon-red"
                                  onClick={() => openAlertDialog(article._id)}
                                >
                                  <MdDelete />
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showAlter && (
        <Swal
          danger
          showCancel
          confirmBtnText={
            alertLoader ? (
              <span>
                Confirm <Spinner size="sm" />
              </span>
            ) : (
              "Confirm"
            )
          }
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDelete}
          onCancel={() => setShowAlter(false)}
          focusCancelBtn
        >
          You want to delete this article
        </Swal>
      )}

      {isModalOpen && (
        <Modal isOpen={isModalOpen} toggle={closeModal}>
          <ModalHeader toggle={closeModal}>Article Details</ModalHeader>
          <ModalBody style={{padding:'1.5rem'}}>
            <ArticleDetails articleId={selectedArticleId} />
          </ModalBody>
        </Modal>
      )}
    </>
  );
}

export default ArticleList;